<template>
  <div class="work-list">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :model="searchForm" inline>
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入用户昵称"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        
        <el-form-item label="工时类型">
          <el-select v-model="searchForm.workMode" placeholder="请选择" clearable style="width: 150px">
            <el-option label="一天工" value="full" />
            <el-option label="半天工" value="half" />
            <el-option label="小时工" value="hour" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="班次类型">
          <el-select v-model="searchForm.shiftType" placeholder="请选择" clearable style="width: 120px">
            <el-option label="白班" :value="1" />
            <el-option label="夜班" :value="2" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="结算状态">
          <el-select v-model="searchForm.isSettled" placeholder="请选择" clearable style="width: 120px">
            <el-option label="未结算" :value="0" />
            <el-option label="已结算" :value="1" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="项目">
          <el-select v-model="searchForm.teamId" placeholder="请选择" clearable style="width: 180px">
            <el-option
              v-for="team in teamOptions"
              :key="team.id"
              :label="team.name"
              :value="team.id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="收支类型">
          <el-select v-model="searchForm.recordType" placeholder="请选择" clearable style="width: 120px">
            <el-option label="收入" value="收入" />
            <el-option label="支出" value="支出" />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 表格 -->
    <el-card class="table-card mt-20">
      <el-table :data="workList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="userName" label="用户" />
        <el-table-column prop="teamName" label="项目" />
        <el-table-column prop="workDate" label="工作日期" width="120" />
        <el-table-column label="记录来源" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.recordSource === '包工头代记' ? 'warning' : 'primary'" size="small">
              {{ scope.row.recordSource || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="记录类型" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.recordType === '支出' ? 'danger' : 'success'">
              {{ scope.row.recordType }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="工时类型" width="100">
          <template slot-scope="scope">
            <span
              class="work-mode-tag"
              :class="getWorkModeClass(scope.row.workMode)"
            >
              {{ getWorkModeText(scope.row.workMode, scope.row.workHours) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="班次" width="70">
          <template slot-scope="scope">
            <el-tag :type="scope.row.shiftType === 2 ? 'warning' : 'info'" size="small">
              {{ scope.row.shiftType === 2 ? '夜班' : '白班' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="workHours" label="工时" width="80">
          <template slot-scope="scope">
            {{ scope.row.workHours }}小时
          </template>
        </el-table-column>
        <el-table-column prop="dailyWage" label="日薪" width="100">
          <template slot-scope="scope">
            <span :class="scope.row.recordType === '支出' ? 'text-expense' : 'text-income'">
              ¥{{ scope.row.dailyWage }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="加班" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.overtimeHours > 0" class="text-overtime">
              {{ scope.row.overtimeHours }}h ¥{{ scope.row.overtimePay || 0 }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="夜班补贴" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.shiftType === 2 && scope.row.nightSubsidy > 0" class="text-night">
              ¥{{ scope.row.nightSubsidy }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="总金额" width="100">
          <template slot-scope="scope">
            <span :class="scope.row.recordType === '支出' ? 'text-expense' : 'text-primary'">
              ¥{{ calculateTotal(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="结算状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isSettled === 1 ? 'success' : 'warning'">
              {{ scope.row.isSettled === 1 ? '已结算' : '未结算' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="记录时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        class="mt-20"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WorkList',
  data() {
    return {
      searchForm: {
        keyword: '',
        workMode: '',
        shiftType: null,
        isSettled: null,
        teamId: null,
        recordType: ''
      },
      teamOptions: [],
      workList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false
    }
  },
  created() {
    this.loadTeamOptions()
    this.loadWorkList()
  },
  methods: {
    async loadWorkList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm
        }
        const res = await this.$http.get('/admin/work/list', { params })
        this.workList = res.records || []
        this.total = res.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.pageNum = 1
      this.loadWorkList()
    },
    
    handleReset() {
      this.searchForm = {
        keyword: '',
        workMode: '',
        shiftType: null,
        isSettled: null,
        teamId: null,
        recordType: ''
      }
      this.handleSearch()
    },
    
    async loadTeamOptions() {
      try {
        const res = await this.$http.get('/admin/team/list', { params: { pageNum: 1, pageSize: 9999 } })
        this.teamOptions = res.records || []
      } catch (error) {
        console.error(error)
      }
    },
    
    handlePageChange(page) {
      this.pageNum = page
      this.loadWorkList()
    },
    
    handleSizeChange(size) {
      this.pageSize = size
      this.handleSearch()
    },
    
    // 工时类型文字
    getWorkModeText(mode, hours) {
      if (mode === 'full') return '一天工'
      if (mode === 'half') return '半天工'
      if (mode === 'hour') return (hours || 0) + '小时'
      // 兼容旧数据
      const h = Number(hours) || 0
      if (h >= 8) return '一天工'
      if (h >= 4) return '半天工'
      return h + '小时'
    },
    
    // 工时类型样式类
    getWorkModeClass(mode) {
      if (mode === 'full') return 'full-day'
      if (mode === 'half') return 'half-day'
      if (mode === 'hour') return 'hour-day'
      return 'full-day'
    },
    
    calculateTotal(row) {
      const daily = Number(row.dailyWage) || 0
      const overtime = Number(row.overtimePay) || 0
      const nightSubsidy = Number(row.nightSubsidy) || 0
      const bonus = Number(row.bonus) || 0
      const deduction = Number(row.deduction) || 0
      return (daily + overtime + nightSubsidy + bonus - deduction).toFixed(2)
    },
    
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped lang="scss">
.work-list {
  .search-card {
    ::v-deep .el-card__body {
      padding-bottom: 0;
    }
  }
  
  .text-primary {
    color: #409EFF;
    font-weight: bold;
  }
  
  .text-expense {
    color: #F56C6C;
    font-weight: bold;
  }
  
  .text-income {
    color: #67C23A;
    font-weight: bold;
  }
  
  .text-overtime {
    color: #ff7a00;
    font-size: 12px;
  }

  .text-night {
    color: #E6A23C;
    font-size: 12px;
    font-weight: bold;
  }

  .text-muted {
    color: #999;
  }
  
  // 工时类型标签样式
  .work-mode-tag {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
  
  // 一天工 - 橘色背景
  .work-mode-tag.full-day {
    background-color: #ff7a00;
    color: #fff;
  }
  
  // 半天工 - 橘色对角线背景（右下角）
  .work-mode-tag.half-day {
    background: linear-gradient(135deg, transparent 50%, #ff7a00 50%);
    color: #ff7a00;
    position: relative;
  }
  
  // 小时工 - 紫色对角线背景（右下角）
  .work-mode-tag.hour-day {
    background: linear-gradient(135deg, transparent 50%, #722ed1 50%);
    color: #722ed1;
  }
}
</style>
